<div
  class="flex flex-col rounded-lg overflow-hidden shadow-lg cursor-pointer"
  [style.background]="model().series.color ? model().series.color : '#000000'"
>
  <div
    class="h-[11.85rem]"
    [style.background]="model().series.color ? model().series.color : '#000000'"
  >
    <img
      [src]="model().images?.length ? model()!.images![0] : ''"
      [alt]="model().title"
      width="336"
      height="224"
      class="w-full h-48 object-cover rounded"
    />
  </div>

  <div
    class="flex flex-col justify-center text-gray-100"
    [style.background]="
      model().series.color ? `color-mix(${model().series.color} 90%, #000000 10%)` : '#000000'
    "
  >
    <span class="font-extrabold text-center pt-2" [innerHTML]="model().title"></span>

    <div class="flex gap-2 py-1 justify-center text-gray-100">
      <div class="flex flex-col items-center">
        <span class="font-extrabold">{{ model().beds }}</span>
        <span>beds</span>
      </div>

      <div class="flex flex-col items-center">
        <span class="font-extrabold">{{ model().baths.value }}</span>
        <span>baths</span>
      </div>

      <div class="flex flex-col items-center">
        <span class="font-extrabold">{{ model().garage.cars }} Car</span>
        <span>garage</span>
      </div>
    </div>
  </div>
</div>
